import { MdOutlineCategory } from 'react-icons/md';
import lazyPage from '../shared/lazyPage';

const ContractTypes = lazyPage(() => import('./ContractTypes'));

// Sections of the contracts settings: the module's own settings page and the host's settings page
// (ContractsSettingsPanel) show the same list. Add a section here.
// labelKey: a key of the "contracts" namespace.
export const contractsSettingsSections = [
    { key: 'types', labelKey: 'settings.types', Icon: MdOutlineCategory, Component: ContractTypes },
];
